const stateSelector = (state) => state.depositAccount;

export const selectDepositAccountIsFetching = (state) => stateSelector(state).isFetching;
export const selectDepositAccountIsCreating = (state) => stateSelector(state).isCreating;
export const selectDepositAccountIsError = (state) => stateSelector(state).isError;
export const selectDepositAccountLoaded = (state) => stateSelector(state).isLoaded;
export const selectDepositAccount = (state) => stateSelector(state).account;
